module.exports = __webpack_public_path__ + "img/sj.ae547dbe.svg";